import React from "react"
import { useStaticQuery, graphql } from "gatsby"

import Infobox from "./infobox"

export default (props) => {
  const { translations } = useStaticQuery(graphql`
    query {
      translations: translationsJson {
        global {
          # -- MOVED TO components/infoblocks
          # current
          # facts
          # directions
          # vegetation
          # communications
          # parking
          # surface
          # hills
          # regulations
          # ---
          length
          time
          difficulty
          visit
          download
          website
          documents
          address
          telephone
          email
          openingHours
          siteOpened
          siteClosed
          monday
          tuesday
          wednesday
          thursday
          friday
          saturday
          sunday
        }
      }
    }
  `)

  return <Infobox {...props} translations={translations} />
}
